/* unplugin-vue-components disabled */import { render } from "./ClassificationComponent1.vue?vue&type=template&id=037a55a1&scoped=true"
import script from "./ClassificationComponent1.vue?vue&type=script&lang=js"
export * from "./ClassificationComponent1.vue?vue&type=script&lang=js"

import "./ClassificationComponent1.vue?vue&type=style&index=0&id=037a55a1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037a55a1"]])

export default __exports__